import Swal from 'sweetalert2';

import Plugin from '@ckeditor/ckeditor5-core/src/plugin';

import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';

import AmazonIcon from '../icons/amazon.svg';

import MediaEmbed from '@ckeditor/ckeditor5-media-embed/src/mediaembed.js';

export default class Amazon extends Plugin {
    static get requires() {
        return [MediaEmbed];
    }

    init() {
        const editor = this.editor;

        editor.ui.componentFactory.add('amazon', (locale) => {
            const view = new ButtonView(locale);

            view.set({
                label: 'Coloque o id',
                icon: AmazonIcon,
                tooltip: true,
            });

          
            view.on('execute', async () => {
                const { value: id } = await Swal.fire({
                    input: 'text',
                    inputPlaceholder: 'Coloque o ID',
                });

                if (id) {
                    editor.model.change(() => {
                        const content = ` <p>[template="btn" id="${id}"]</p>`;

                        const viewFragment = editor.data.processor.toView(content);
                        const modelFragment = editor.data.toModel(viewFragment);

                        editor.model.insertContent(
                            modelFragment,
                            editor.model.document.selection
                        );
                    });
                }
            });

            return view;
        });
    }
}
